/**
 * Índice de las secciones de un formulario: una lista fija a la izquierda que,
 * al hacer clic, desplaza suavemente hasta la sección y la resalta un momento.
 * Usa el mismo estilo sticky de la barra de «Artículo nuevo». Sirve tanto en el
 * editor de procedimientos como en la ejecución: recibe el id del elemento de
 * cada sección en el DOM.
 */
export function IndiceSecciones({ secciones }: { secciones: { id: string; nombre: string }[] }): JSX.Element | null {
  if (secciones.length === 0) return null;

  function irA(id: string): void {
    const el = document.getElementById(id);
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    el.classList.add('seccion-resaltada');
    window.setTimeout(() => el.classList.remove('seccion-resaltada'), 1400);
  }

  return (
    <nav className="indice-secciones" aria-label="Índice de secciones">
      <span className="indice-secciones-titulo">Índice</span>
      {secciones.map((s, n) => {
        const nombre = s.nombre.trim() || 'Sección sin nombre';
        return (
          <button key={s.id} type="button" title={nombre} onClick={() => irA(s.id)}>
            <span className="indice-secciones-numero">{n + 1}</span>
            <span className="indice-secciones-nombre">{nombre}</span>
          </button>
        );
      })}
    </nav>
  );
}
